import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.stripe_pending_settlement_status_ */
export type StripePendingSettlementStatusId = string & {
  __brand: 'StripePendingSettlementStatusId'
}

/** Represents the table public.stripe_pending_settlement_status_ */
export default interface StripePendingSettlementStatusTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<
    StripePendingSettlementStatusId,
    StripePendingSettlementStatusId,
    StripePendingSettlementStatusId
  >

  /** Database type: pg_catalog.text */
  description: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>
}

export type StripePendingSettlementStatus =
  Selectable<StripePendingSettlementStatusTable>

export type StripePendingSettlementStatusInitializer =
  Insertable<StripePendingSettlementStatusTable>

export type StripePendingSettlementStatusMutator =
  Updateable<StripePendingSettlementStatusTable>

export const stripePendingSettlementStatusId =
  z.string() as unknown as z.Schema<StripePendingSettlementStatusId>

export const stripePendingSettlementStatus = z.object({
  id: stripePendingSettlementStatusId,
  description: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<StripePendingSettlementStatus>

export const stripePendingSettlementStatusInitializer = z.object({
  id: stripePendingSettlementStatusId,
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<StripePendingSettlementStatusInitializer>

export const stripePendingSettlementStatusMutator = z.object({
  id: stripePendingSettlementStatusId.optional(),
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<StripePendingSettlementStatusMutator>
